// Store fetched tasks for passing to iframe
let cachedTasks = []

const taskListforInvoice = () => {
  const invoiceId = window.location.pathname.split('/').pop()
  
  // Wait for the real content wrapper to be created
  const waitForNotesSection = setInterval(() => {
    const realContentWrapper = document.querySelector('#invoice-section-real-content')
    
    if (realContentWrapper) {
      clearInterval(waitForNotesSection)
      // Check if task list is already injected
      if (document.querySelector('#invoice-task-list-container')) {
        return
      }
      
      // Create task list container
      const taskListContainer = document.createElement('div')
      taskListContainer.id = 'invoice-task-list-container'
      taskListContainer.style.cssText = `
        margin-top: 12px;
        padding-top: 16px;
        border-top: 1px solid #eee;
      `
      
      // Create header
      const header = document.createElement('div')
      header.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
      `
      
      const title = document.createElement('h3')
      title.textContent = 'Aufgaben'
      title.style.cssText = `
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: rgba(0, 0, 0, 0.85);
      `
      
      const newTaskButton = document.createElement('button')
      newTaskButton.id = 'invoice-new-task-button'
      newTaskButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 5v14M5 12h14"/>
        </svg>
      `
      newTaskButton.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 14px;
        color: rgba(0, 0, 0, 0.85);
        background-color: transparent;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.2s;
      `
      newTaskButton.onmouseover = () => {
        newTaskButton.style.backgroundColor = 'rgba(0, 0, 0, 0.16)'
      }
      newTaskButton.onmouseout = () => {
        newTaskButton.style.backgroundColor = 'transparent'
      }
      newTaskButton.onclick = () => {
        openTaskModal('create')
      }
      
      header.appendChild(title)
      header.appendChild(newTaskButton)
      
      // Create task list element
      const taskList = document.createElement('div')
      taskList.id = 'invoice-task-list'
      taskList.style.cssText = `
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-height: 170px;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
      `
      
      taskListContainer.appendChild(header)
      taskListContainer.appendChild(taskList)
      realContentWrapper.appendChild(taskListContainer)
      
      // Fetch tasks
      fetchTasks(invoiceId, taskList)
    }
  }, 100)
}

const fetchTasks = async (invoiceId, taskListElement) => {
  try {
    const authData = localStorage.getItem('auth')
    if (!authData) {
      console.error('No authentication data found')
      // Mark tasks as fetched even on auth error
      if (window.invoiceSectionFetchState) {
        window.invoiceSectionFetchState.markTasksFetched()
      }
      return
    }
    
    const { token } = JSON.parse(authData)
    
    // Build query params
    const params = new URLSearchParams()
    params.append('assignedObjectType', 'invoice')
    params.append('assignedObjectId', invoiceId)
    params.append('limit', '100')
    
    const response = await fetch(`${baseApiUrl}/api/tasks?${params.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    
    if (!response.ok) {
      throw new Error('Failed to fetch tasks')
    }
    
    const data = await response.json()
    const tasks = data.tasks || []
    
    // Cache tasks for passing to iframe later
    cachedTasks = tasks
    
    // Clear existing tasks
    taskListElement.innerHTML = ''
    
    if (tasks.length === 0) {
      const emptyState = document.createElement('p')
      emptyState.style.cssText = `
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        margin: 0;
        padding: 8px 0;
      `
      emptyState.textContent = 'Keine Aufgaben vorhanden'
      taskListElement.appendChild(emptyState)
    } else {
      // Render tasks
      tasks.forEach(task => {
        const taskItem = createTaskItem(task)
        taskListElement.appendChild(taskItem)
      })
    }
    
    // Mark tasks as fetched on success
    if (window.invoiceSectionFetchState) {
      window.invoiceSectionFetchState.markTasksFetched()
    }
    
  } catch (error) {
    console.error('Error fetching tasks:', error)
    taskListElement.innerHTML = ''
    const errorMessage = document.createElement('p')
    errorMessage.style.cssText = `
      color: #cf1322;
      font-size: 14px;
      margin: 0;
      padding: 8px 0;
    `
    errorMessage.textContent = 'Fehler beim Laden der Aufgaben'
    taskListElement.appendChild(errorMessage)
    
    // Mark tasks as fetched even on error
    if (window.invoiceSectionFetchState) {
      window.invoiceSectionFetchState.markTasksFetched()
    }
  }
}

const createTaskItem = (task) => {
  const isCompleted = task.status === 'Completed'
  const dueDateValue = new Date(task.dueDate)
  const isOverdue = dueDateValue < new Date() && !isCompleted
  
  const taskItem = document.createElement('div')
  taskItem.onclick = () => {
    openTaskModal('view', task.id)
  }
  taskItem.style.cssText = `
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid ${isOverdue ? '#ff4d4f' : '#eee'};
    cursor: pointer;
  `
  
  // Title
  const titleElement = document.createElement('span')
  titleElement.style.cssText = `
    font-size: 14px;
    font-weight: 500;
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
  titleElement.textContent = task.title
  
  // Priority badge
  const priorityBadge = document.createElement('span')
  const priorityColors = {
    'High': {  text : 'rgb(239, 68, 68)'  },
    'Medium': { text: 'rgb(202, 138, 4)' },
    'Low': { text: 'rgb(22, 163, 74)' }
  }
  const priorityStyle = priorityColors[task.priority] || { bg: '#f5f5f5', text: '#666' }
  const priorityLabels = {
    'High': 'Hoch',
    'Medium': 'Mittel',
    'Low': 'Niedrig'
  }
  priorityBadge.style.cssText = `
    border-radius: 4px;
    background-color :#f5f5f5;
    color: ${priorityStyle.text};
    opacity: 0.7;
    font-size: 12px;
    font-weight: 500;
    flex-shrink: 0;
    width: 50px;
    text-align: center;
  `
  priorityBadge.textContent = priorityLabels[task.priority] || task.priority
  
  // Due date
  const dueDate = document.createElement('span')
  dueDate.style.cssText = `
    font-size: 12px;
    color: ${isOverdue ? '#cf1322' : 'rgba(0, 0, 0, 0.45)'};
    font-weight: ${isOverdue ? '500' : 'normal'};
    flex-shrink: 0;
  `
  dueDate.textContent = `${isOverdue ? 'Überfällig: ' : ''}${dueDateValue.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  })}`
  
  // Checkbox
  const checkbox = document.createElement('input')
  checkbox.type = 'checkbox'
  checkbox.checked = isCompleted
  checkbox.disabled = isCompleted // Disable if already completed
  checkbox.style.cssText = `
    width: 18px;
    height: 18px;
    cursor: ${isCompleted ? 'default' : 'pointer'};
    accent-color:rgb(125, 125, 125);
    flex-shrink: 0;
  `
  checkbox.onclick = async (e) => {
    e.stopPropagation() // Prevent opening the modal
    
    if (!checkbox.checked) {
      // Prevent unchecking - keep it checked and disabled
      checkbox.checked = true
      return
    }
    
    const newStatus = 'Completed'
    checkbox.disabled = true // Disable while updating
    
    try {
      const authData = localStorage.getItem('auth')
      if (!authData) {
        console.error('No authentication data found')
        checkbox.checked = !checkbox.checked // Revert
        checkbox.disabled = false
        return
      }
      
      const { token } = JSON.parse(authData)
      
      const response = await fetch(`${baseApiUrl}/api/tasks/${task.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status: newStatus })
      })
      
      if (!response.ok) {
        throw new Error('Failed to update task status')
      }
      
      // Update cached task
      const taskIndex = cachedTasks.findIndex(t => t.id === task.id)
      if (taskIndex !== -1) {
        cachedTasks[taskIndex].status = newStatus
      }
      
      // Update visual state - task is now completed
      taskItem.style.border = '1px solid #eee'
      dueDate.style.color = 'rgba(0, 0, 0, 0.45)'
      dueDate.style.fontWeight = 'normal'
      dueDate.textContent = dueDateValue.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      })
      
      // Keep checkbox disabled and update cursor
      checkbox.style.cursor = 'default'
      
    } catch (error) {
      console.error('Error updating task status:', error)
      checkbox.checked = false // Revert on error
      checkbox.disabled = false
      checkbox.style.cursor = 'pointer'
    }
  }
  
  taskItem.appendChild(priorityBadge)
  taskItem.appendChild(titleElement)
  taskItem.appendChild(dueDate)
  taskItem.appendChild(checkbox)
  
  return taskItem
}

const openTaskModal = (modalViewMode, taskId = null) => {
  const invoiceId = window.location.pathname.split('/').pop()
  
  // Find task from cache if viewing
  const taskData = taskId ? cachedTasks.find(t => t.id === taskId) : null
  
  // Create modal overlay
  const modalOverlay = document.createElement('div')
  modalOverlay.id = 'task-modal-overlay'
  modalOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  `
  
  // Build iframe URL with query params
  const params = new URLSearchParams()
  params.append('type', 'invoice')
  params.append('id', invoiceId)
  params.append('modalViewMode', modalViewMode)
  params.append('className', 'bg-transparent p-0 m-0 w-full')
  
  const iframeUrl = `${baseApiUrl}/injects/tasks?${params.toString()}`
  
  // Dashboard dialog is Tailwind `sm:max-w-lg` (32rem) inside Lux, where 1rem is
  // 16px. This script runs on Impower, whose root font-size is smaller, so `32rem`
  // here would shrink the iframe. Use the Lux pixel width instead.
  const iframeContainer = document.createElement('div')
  iframeContainer.style.cssText = `
    width: 512px;
    max-width: calc(100vw - 2rem);
    height: 85vh;
    max-height: 85vh;
    border-radius: 12px;
    overflow: hidden;
    background: white;
    position: relative;
  `
  
  // Create loading spinner wrapper (for centering)
  const spinnerWrapper = document.createElement('div')
  spinnerWrapper.style.cssText = `
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  `
  
  // Create loading spinner
  const spinner = document.createElement('div')
  spinner.style.cssText = `
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #1890ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  `
  spinnerWrapper.appendChild(spinner)
  
  // Add keyframes for spinner animation
  if (!document.getElementById('spinner-keyframes')) {
    const style = document.createElement('style')
    style.id = 'spinner-keyframes'
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      @keyframes fadeOut {
        0% { opacity: 1; }
        100% { opacity: 0; }
      }
      @keyframes fadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
      }
    `
    document.head.appendChild(style)
  }
  
  // Create iframe
  const iframe = document.createElement('iframe')
  iframe.src = iframeUrl
  iframe.style.cssText = `
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    opacity: 0;
  `
  
  // Hide spinner and fade in iframe after 500ms
  // This is to avoid the flash of the iframe before it is loaded
  iframe.onload = () => {
    setTimeout(() => {
      spinnerWrapper.style.animation = 'fadeOut 0.3s ease-out forwards'
      iframe.style.animation = 'fadeIn 0.3s ease-out forwards'
      spinnerWrapper.addEventListener('animationend', () => {
        spinnerWrapper.style.display = 'none'
      })
    }, 500)
  }
  
  iframeContainer.appendChild(spinnerWrapper)
  iframeContainer.appendChild(iframe)
  modalOverlay.appendChild(iframeContainer)
  
  // Track if modal can be closed (disabled during loading states)
  let canCloseModal = true
  
  // Close modal on overlay click
  modalOverlay.onclick = (e) => {
    if (e.target === modalOverlay && canCloseModal) {
      closeTaskModal()
    }
  }
  
  // Close modal on Escape key
  const handleKeyDown = (e) => {
    if (e.key === 'Escape' && canCloseModal) {
      closeTaskModal()
    }
  }
  document.addEventListener('keydown', handleKeyDown)
  
  // Listen for messages from iframe
  const handleMessage = (event) => {
    if (event.data.type === 'IFRAME_READY' && taskData) {
      // Send task data to iframe when it's ready
      iframe.contentWindow.postMessage({ type: 'SET_TASK_DATA', task: taskData }, '*')
    } else if (event.data.type === 'CLOSE_MODAL') {
      closeTaskModal()
      // Refresh the task list after modal closes
      const taskListElement = document.getElementById('invoice-task-list')
      if (taskListElement) {
        fetchTasks(invoiceId, taskListElement)
      }
    } else if (event.data.type === 'LOADING_STATE_CHANGE') {
      canCloseModal = event.data.canCloseModal
    } else if (event.data.type === 'TASK_MODAL_SIZE' && event.data.height) {
      const maxHeight = Math.floor(window.innerHeight * 0.85)
      const nextHeight = Math.min(Math.ceil(event.data.height) + 2, maxHeight)
      iframeContainer.style.height = `${Math.max(nextHeight, 1)}px`
      if (event.data.width) {
        const maxWidth = Math.floor(window.innerWidth - 32)
        iframeContainer.style.width = `${Math.min(Math.ceil(event.data.width), maxWidth)}px`
      }
    }
  }
  window.addEventListener('message', handleMessage)
  
  // Close modal function
  const closeTaskModal = () => {
    document.removeEventListener('keydown', handleKeyDown)
    window.removeEventListener('message', handleMessage)
    modalOverlay.remove()
  }
  
  // Store close function for external access
  modalOverlay._close = closeTaskModal
  
  document.body.appendChild(modalOverlay)
}